import React from 'react';
import { useParams } from 'react-router-dom';

import { httpClient, notificationsService } from '@web/services/singletons';
import { useAuthState } from '@packages/contexts/auth';
import { useMarkNotificationAsReadOnLoad } from '@packages/contexts/notifications';
import { getLogger } from '@packages/core/logging';
import { Button } from '@packages/ui/shared';
import { useTranslation } from 'react-i18next';

const logger = getLogger('web');

export function ReportsDownload() {
    const { t } = useTranslation();
    const { account, token } = useAuthState();
    const { reportId } = useParams<{ reportId: string }>();

    useMarkNotificationAsReadOnLoad(notificationsService);

    const onClickDownloadButton = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        const options = {
            headers: {
                'X-Subcomm-Access-Token': token,
            },
        };

        fetch(`${httpClient.baseUrl}/reports/download/${reportId}`, options)
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Failed to get download information');
                }
                return res.json();
            })
            .then((data) => {
                // data should contain { reportId, downloadUrl }
                if (data.downloadUrl) {
                    // Extract filename from the downloadUrl
                    let filename = 'report.csv'; // default filename
                    try {
                        const parsedUrl = new URL(data.downloadUrl);
                        const respContentDisp = Array.from(parsedUrl.searchParams).filter(
                            (sp) => sp[0] === 'response-content-disposition'
                        );
                        if (respContentDisp && respContentDisp.length > 0) {
                            const contentDispositionHeader = respContentDisp[0][1];
                            if (contentDispositionHeader) {
                                let filenameSplited = contentDispositionHeader.split('filename=');
                                if (filenameSplited && filenameSplited.length > 1) {
                                    filename = filenameSplited[1].split(';')[0].replaceAll('"', '');
                                }
                            }
                        }
                    } catch (error) {
                        logger.warn('Failed to extract the filename from the download URL', { error });
                    }

                    // Download the actual file from the downloadUrl
                    return fetch(data.downloadUrl)
                        .then((response) => response.blob())
                        .then((blob) => {
                            const file = window.URL.createObjectURL(blob);
                            let a = document.createElement('a');
                            document.body.appendChild(a);
                            a.setAttribute('style', 'display: none');
                            a.href = file;
                            a.download = filename;
                            a.click();
                            window.URL.revokeObjectURL(file);
                            document.body.removeChild(a);
                        });
                } else {
                    throw new Error('No download URL provided');
                }
            })
            .catch((error) => {
                logger.error('Failed to download the report', { error, reportId });
                // You can add a toast notification here if needed
            });
    };

    return (
        <div className="d-flex flex-row justify-content-center align-items-top mt-10">
            {account?.systemCapabilities.canExportQMRsAsCsv && (
                <Button>
                    <a
                        href="javascript:void(0);"
                        style={{ textDecoration: 'none', color: 'white' }}
                        onClick={(e) => {
                            onClickDownloadButton(e);
                        }}
                    >
                        {t('buttons:downloadReport', 'Download Report')}
                    </a>
                </Button>
            )}
        </div>
    );
}

export default ReportsDownload;
